function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  d: "M2.2 3.48c0-.27.21-.48.48-.48h7.04a.48.48 0 010 .96H2.68a.48.48 0 01-.48-.48zM2.2 5.88c0-.27.21-.48.48-.48h7.04a.48.48 0 010 .96H2.68a.48.48 0 01-.48-.48zM2.2 8.28c0-.27.21-.48.48-.48h7.04a.48.48 0 010 .96H2.68a.48.48 0 01-.48-.48zM3.8 10.68c0-.27.21-.48.48-.48h3.04a.48.48 0 110 .96H4.28a.48.48 0 01-.48-.48zM3.8 12.28c0-.27.21-.48.48-.48h3.04a.48.48 0 110 .96H4.28a.48.48 0 01-.48-.48zM2.2 12.28a.48.48 0 11.96 0 .48.48 0 01-.96 0zM2.2 10.68a.48.48 0 11.96 0 .48.48 0 01-.96 0z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M0 1.44C0 .64.64 0 1.44 0h9.84c.8 0 1.44.64 1.44 1.44v7.38a.62.62 0 11-1.23 0V1.44a.2.2 0 00-.2-.2H1.43a.2.2 0 00-.2.2v13.12c0 .12.08.2.2.2h7.8a.62.62 0 110 1.24h-7.8C.64 16 0 15.36 0 14.56V1.44z",
  clipRule: "evenodd"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M14.33 10.3a.6.6 0 01.17.83l-2 3a.76.76 0 01-1.27 0l-.93-1.4a.6.6 0 011-.66l.57.85 1.63-2.45a.6.6 0 01.83-.17z",
  clipRule: "evenodd"
});

function SvgAnalysis2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 16,
    fill: "none",
    viewBox: "0 0 15 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAnalysis2);
export default __webpack_public_path__ + "static/media/analysis2.61c9df62.svg";
export { ForwardRef as ReactComponent };